import { NgModule } from '@angular/core';
import { FormatDatePipe } from './format-date';

@NgModule({
  declarations: [FormatDatePipe],
  exports: [FormatDatePipe],
})
export class FormatDatePipeModule {}
